import React, { useState, useRef } from 'react';

interface HoverPopupProps {
    popupHeader: React.ReactNode;
    popupContent: React.ReactNode;
    popupFooter?: React.ReactNode;
    delay?: number;
    closeDelay?: number;
    children: React.ReactNode;
    popupWidthClass?: string;
}

const HoverPopup: React.FC<HoverPopupProps> = ({
                                                   popupHeader,
                                                   popupContent,
                                                   popupFooter,
                                                   delay = 500,
                                                   closeDelay = 500,
                                                   children,
                                                   popupWidthClass = "min-w-[200px] max-w-[90vw]",
                                               }) => {
    const [visible, setVisible] = useState(false);
    const openTimerRef = useRef<number | null>(null);
    const closeTimerRef = useRef<number | null>(null);

    const handleMouseEnter = () => {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
        if (!visible) {
            openTimerRef.current = window.setTimeout(() => {
                setVisible(true);
            }, delay);
        }
    };

    const handleMouseLeave = () => {
        if (openTimerRef.current) {
            clearTimeout(openTimerRef.current);
            openTimerRef.current = null;
        }
        closeTimerRef.current = window.setTimeout(() => {
            setVisible(false);
        }, closeDelay);
    };

    return (
        <div
            className="relative inline-block"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {children}
            {visible && (
                <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 z-50"
                >
                    <div
                        className={`card border border-gray-200 bg-white rounded-lg ${popupWidthClass}`}
                        style={{ wordBreak: 'normal', overflowWrap: 'break-word' }}
                    >
                        <div className="card-header px-4 py-2 border-b border-gray-200">
                            <h3 className="card-title text-sm font-semibold">
                                {popupHeader}
                            </h3>
                        </div>
                        <div className="card-body p-4 text-xs">
                            {popupContent}
                        </div>
                        {popupFooter && (
                            <div className="card-footer px-4 py-3 border-b border-gray-200 align-middle">
                                {popupFooter}
                            </div>
                        )}
                    </div>

                    {/* Triangle indicator */}
                    <div
                        className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0
                            border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-gray-200"
                    />
                </div>
            )}
        </div>
    );
};

export default HoverPopup;
